module.exports = __webpack_public_path__ + "static/media/flutter-icon.acef99de.svg";